// extracted by mini-css-extract-plugin
export default {"menu":"Nav_menu__Qc15o","icon":"Nav_icon__QMfjt","label":"Nav_label__LaJxI"};